import { mxgraphInstance } from './mxgraphFactory';

/**
 * Handler
 */
export const mxCellHighlight = mxgraphInstance.mxCellHighlight;
export const mxCellMarker = mxgraphInstance.mxCellMarker;
export const mxCellTracker = mxgraphInstance.mxCellTracker;
export const mxConnectionHandler = mxgraphInstance.mxConnectionHandler;
export const mxConstraintHandler = mxgraphInstance.mxConstraintHandler;
export const mxEdgeHandler = mxgraphInstance.mxEdgeHandler;
export const mxEdgeSegmentHandler = mxgraphInstance.mxEdgeSegmentHandler;
export const mxElbowEdgeHandler = mxgraphInstance.mxElbowEdgeHandler;
export const mxGraphHandler = mxgraphInstance.mxGraphHandler;
export const mxHandle = mxgraphInstance.mxHandle;
export const mxKeyHandler = mxgraphInstance.mxKeyHandler;
export const mxPanningHandler = mxgraphInstance.mxPanningHandler;
export const mxPopupMenuHandler = mxgraphInstance.mxPopupMenuHandler;
export const mxRubberband = mxgraphInstance.mxRubberband;
export const mxSelectionCellsHandler = mxgraphInstance.mxSelectionCellsHandler;
export const mxTooltipHandler = mxgraphInstance.mxTooltipHandler;
export const mxVertexHandler = mxgraphInstance.mxVertexHandler;